<template>
  <loading-popup :title="loadingTitle" :subtitle="loadingSubtitle"/>
</template>

<script>
import moment from 'moment';
import LoadingPopup from '@/base-components/onboarding/LoadingPopup';
import Segment from '@/Segment';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'LoadingPopupWithAsyncFallback',
  components: {
    LoadingPopup,
  },
  data() {
    return {
      loadingIsLong: false,
    };
  },
  async created() {
    const loadingTimeInSecs = moment().diff(moment(this.loadingStartTime), 'seconds');
    if (loadingTimeInSecs > 30) {
      await this.setLoadingIsLong();
    } else {
      setTimeout(async () => {
        await this.setLoadingIsLong();
      }, (30 - loadingTimeInSecs) * 1000);
    }
  },
  computed: {
    ...mapState('onboardingState', ['loadingStartTime']),
    ...mapGetters('onboardingState', ['sourceName']),
    ...mapGetters('sourceFields', ['getSourceBySourceName']),
    source() {
      return this.getSourceBySourceName(this.sourceName);
    },
    sourceTypeString() {
      return this.source.type === 'bank' ? 'הבנק' : 'חברת האשראי';
    },
    loadingTitle() {
      if (this.loadingIsLong) {
        Segment.trackUserGot('CredentialsConnectionTakesTooLongLoaderShown', { sourceName: this.source.sourceName });
        return `החיבור לאתר ${this.sourceTypeString} לוקח קצת יותר זמן מהרגיל`;
      }
      Segment.trackUserGot('CredentialsConnectionLoaderShown', { sourceName: this.source.sourceName });
      return 'עוד רגע ממשיכים...';
    },
    loadingSubtitle() {
      if (this.loadingIsLong) {
        return 'המערכת ממשיכה לנסות...';
      }
      return `המערכת מתחברת לאתר ${this.sourceTypeString}.`;
    },
  },
  methods: {
    async setLoadingIsLong() {
      Segment.trackUserGot('TempCredentialsConnectionLoadingLong', { sourceName: this.source.sourceName });
      this.loadingIsLong = true;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
